import { render, staticRenderFns } from "./ProductBlock.vue?vue&type=template&id=b24c3488&scoped=true&"
import script from "./ProductBlock.vue?vue&type=script&lang=js&"
export * from "./ProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductBlock.vue?vue&type=style&index=0&id=b24c3488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c3488",
  null
  
)

export default component.exports